// Delegated so this keeps working for .product-card links inside the
// collection grid after it's replaced by the AJAX filter/sort/pagination
// update in theme-collection.js. No DOMContentLoaded wrapper: this loads
// async and may run after that event has already fired.
document.addEventListener('click', function (e) {
  if (e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) {
    return;
  }

  var link = e.target.closest('.product-card a');
  if (!link) return;

  spinner();
});
